<template>
  <div>
    <p ref="typewriterText"></p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      text: "Ihre maßgeschneiderte Monitor-Auswahl wurde auf Grundlage Ihrer Präferenzen erstellt. Die ausgewählten Monitore bieten beeindruckende Bildschirmgrößen, Auflösungen und Farbgenauigkeit – ideal für Grafikdesign und Gaming. Mit hoher Leistung und nahtloser Multitasking-Unterstützung sind sie perfekt für Ihre Produktivitätsanforderungen geeignet. Genießen Sie ein Seherlebnis, das Ihre Erwartungen übertreffen wird!",
      speed: 10
    };
  },
  mounted() {
    this.typeWriterEffect();
  },
  methods: {
    typeWriterEffect() {
      let element = this.$refs.typewriterText;
      let text = this.text;
      let speed = this.speed;

      let i = 0;
      let line = '';
      let interval = setInterval(() => {
        if (text.charAt(i) === '\n' || i === text.length) {
          element.innerHTML += line + '<br>';
          line = '';
        } else {
          line += text.charAt(i);
        }
        i++;
        if (i > text.length) {
          clearInterval(interval);
        }
      }, speed);
    },
  },
};
</script>

<style scoped></style>